module.exports = __webpack_public_path__ + "img/603.192ab14e.jpg";